import { importEnkatregistretApiV1 } from '@cancercentrum/enkatregistret';

export const importSurveyApiV1 = () => {
    return importEnkatregistretApiV1({
        demo: process.env.RCC_ENV === 'development',
    });
};
